import { create } from 'zustand'

/**
 * Estado compartilhado do drawer da sidebar — usado em mobile (<lg).
 * Em desktop a sidebar é fixa e ignora esses flags.
 */
interface SidebarState {
  open: boolean
  toggle: () => void
  close: () => void
  openIt: () => void
}

export const useSidebarStore = create<SidebarState>((set) => ({
  open: false,
  toggle: () => set((s) => ({ open: !s.open })),
  close: () => set({ open: false }),
  openIt: () => set({ open: true }),
}))
